import React, { Fragment, useEffect, useState } from "react";
import SportsRight from "../../components/sports/SportsRight";
import SportsCenter from "../../components/sports/SportsCenter";
import connect from "react-redux/lib/connect/connect";
import { ClearBetStore } from "../../common/actions/betAction";
import { ClearSportsList } from "../../common/actions/sportsAction";
import { socket } from "../../common/cores/socket";
import { ResizeSportsLiveIframe } from "../../common/cores";
import { SetPageInfo } from "../../common/actions/pageAction";
import TitleBox from "../../components/common/TitleBox";

const Esports = props => {
  const [showLeft, setShowLeft] = useState(false);

    const [roomObj, setRoomObj] = useState({
        pageType: "toto",
        RoomType: "esport",
        sportType: "esport",
        gameType: "prematch",
        esportType: "all",
        sportId: 'all',
    })
        props.SetPageInfo(roomObj);
    // props.ClearBetStore();
    // props.ClearSportsList();
    useEffect(() => {
        // props.ClearBetStore();
        // props.ClearSportsList();
        const roomData = {
            MessageType: "RoomType",
            data: roomObj
        };
        if(window.ws.readyState === 1)
            window.ws.send(JSON.stringify(roomData));
        // props.SetPageInfo(roomObj);
        ResizeSportsLiveIframe();
    }, [roomObj]);


  const onSetShowLeft = () => {
    setShowLeft(!showLeft);
  };
  return (
    <Fragment>
      <TitleBox title="E-스포츠" />
      <div className="contents_wrap">
        <div className="contents_box">
          <SportsCenter
            roomObj={roomObj}
            type="esports"
            onSetShowLeft={onSetShowLeft}
	    setRoomObj={setRoomObj}
          />
          <SportsRight type="esports" />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  { ClearBetStore, ClearSportsList, SetPageInfo }
)(Esports);



// WEBPACK FOOTER //
// ./src/containers/Sports/Esports.js